function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Form, Drawer, Descriptions, Modal, DatePicker, Tag, Input } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, CalendarCheckFill, GraphUpArrow, HourglassSplit } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import NewConsultation from "../components/forms/NewConsultation";
import PatientView from "../components/PatientView";
import NewAppointment from "../components/forms/NewAppointment";
import Appointment from "../components/Appointment";
import PatientPage from "./PatientPage";
import Moment from 'react-moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;

var Consultations = function Consultations() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentDept = _useState2[0],
      setCurrentDept = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptList = _useState4[0],
      setDeptList = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDeptDataLoading = _useState6[0],
      setIsDeptDataLoading = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      queueData = _useState8[0],
      setQueueData = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentQueueItem = _useState10[0],
      setCurrentQueueItem = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isConsultationDrawerVisible = _useState12[0],
      setIsConsultationDrawerVisible = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isBilanDrawerVisible = _useState14[0],
      setIsBilanDrawerVisible = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isHospiDrawerVisible = _useState16[0],
      setIsHospiDrawerVisible = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      searchId = _useState18[0],
      setSearchId = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isPatientModalOpen = _useState20[0],
      setIsPatientModalOpen = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      dataChanged = _useState22[0],
      setDataChanged = _useState22[1];

  var onSearch = function onSearch(v) {
    setSearchId('');

    if (v.length > 0) {
      setSearchId(v); //setIsPatientModalOpen(true); 
    }
  };

  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};

  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        if (Common.currentUser.role == 21) dep = response.data.departments.filter(function (d) {
          return d.label == 'CONSULTATIONS 1';
        });
        if (Common.currentUser.role == 22) dep = response.data.departments.filter(function (d) {
          return d.label == 'CONSULTATIONS 2';
        });
        if (Common.currentUser.role == 23) dep = response.data.departments.filter(function (d) {
          return d.label == 'CONSULTATIONS 3';
        });
        if (Common.currentUser.role == 24) dep = response.data.departments.filter(function (d) {
          return d.label == 'CONSULTATIONS 4';
        });
        if (Common.currentUser.role == 81 || Common.currentUser.role == 91 || Common.currentUser.role == 101) dep = response.data.departments.filter(function (d) {
          return d.label == 'CONSULTATIONS 1' || d.label == 'CONSULTATIONS 2' || d.label == 'CONSULTATIONS 3' || d.label == 'CONSULTATIONS 4';
        }); //let dep = response.data.departments.filter(d => d.dcode == 'CON');     

        var req;

        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString();
        }

        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString();
        }

        if (dep.length == 3) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString() + "," + dep[2].id.toString();
        }

        if (dep.length == 4) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString() + "," + dep[2].id.toString() + "," + dep[3].id.toString();
        }

        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems); //console.log(qresponse.data.queueData);  
        })["catch"](function (error) {
          message.error({
            content: "Err inside" + error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Err out +" + error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ListUl, {
                  size: 35
                }), " File d'attente"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: e.medical_item.label + "(" + e.medical_item.department.label + ")"
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: "Consulter"
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: e.medical_item.label + "(" + e.medical_item.department.label + ")"
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: null,
                            href: "/#/home/patient/" + q.customer.idnumber,
                            size: "small",
                            children: "Consulter"
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2), /*#__PURE__*/_jsxs(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(SearchIcon, {
                  size: 35
                })
              }),
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Search, {
                placeholder: "Entrez ID ou Telephone",
                size: "large",
                onSearch: onSearch,
                enterButton: true,
                style: {
                  width: '100%',
                  marginBottom: '20px'
                }
              }), /*#__PURE__*/_jsx("br", {}), searchId.length > 0 && /*#__PURE__*/_jsx(PatientPage, {
                patientId: searchId
              })]
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CalendarCheckFill, {
                  size: 35
                }), " Rendez-vous"]
              }),
              children: /*#__PURE__*/_jsx(Appointment, {})
            }, 4), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: /*#__PURE__*/_jsxs(Form, {
                  layout: "horizontal",
                  onFinish: onSelectPeriodFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "perdiod",
                    rules: [{
                      required: true,
                      message: "Champ obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {})
                  }), /*#__PURE__*/_jsx(Button, {
                    htmlType: "submit",
                    type: "primary",
                    children: "Chercher"
                  })]
                })
              })
            }, 5)]
          })
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isConsultationDrawerVisible,
      title: "Nouvelle consultation",
      width: 370,
      onClose: function onClose() {
        setIsConsultationDrawerVisible(false);
      },
      closable: true,
      children: currentQueueItem != null && /*#__PURE__*/_jsx(NewConsultation, {
        handler: function handler() {
          setDataChanged(true);
        },
        queueId: currentQueueItem.id,
        queueData: queueData,
        patient: currentQueueItem.customer
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: "Infos patient",
      destroyOnClose: true,
      footer: null,
      visible: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    })]
  });
};

export default Consultations;